interface OutlineCheckIconProps {
    color: string
    height: string
    width: string
}
export default function OutlineCheckIcon({
    color,
    height,
    width
}: OutlineCheckIconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
            d="M64.7327 33.7529C64.7327 51.023 50.7919 65.0059 33.6163 65.0059C16.4408 65.0059 2.5 51.023 2.5 33.7529C2.5 16.4828 16.4408 2.5 33.6163 2.5C50.7919 2.5 64.7327 16.4828 64.7327 33.7529Z" 
            fill="#EBFFF9" 
            stroke="#0ABB89" 
            strokeWidth="5"/>
        <path 
            d="M49.6483 19.6348C50.9151 18.272 53.0423 18.1984 54.3996 19.4703C55.7568 20.7422 55.8302 22.8781 54.5634 24.2408L31.032 49.5555C29.8029 50.8777 27.7543 50.9922 26.3867 49.8152L14.621 39.6893C13.2114 38.4762 13.0481 36.3454 14.2564 34.93C15.4646 33.5147 17.5868 33.3508 18.9964 34.5639L28.3156 42.5842L49.6483 19.6348Z" 
            fill={color}/>
        </svg>
    )
}
